<template>
  <vue-tel-input
    v-model="computedValue"
    :autoDefaultCountry="false"
    :defaultCountry="defaultCountry"
    :inputOptions="inputOptions"
    @blur="$emit('blur')"
  ></vue-tel-input>
</template>

<script>
export default {
  name: "PhoneInput",
  props: ["value", "defaultCountry"],
  data() {
    return {
      inputOptions: {
        placeholder: "Enter the phone number",
        showDialCode: true,
        styleClasses: "form-control"
      }
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value ? this.value : "";
      },
      set(newValue) {
          this.$emit("input", newValue);
      }
    }
  },
  watch: {
    defaultCountry: function(newValue) {
      if (!this.value) {
        this.$refs.telInput.choose(newValue);
      }
    }
  }
};
</script>


<style></style>

